import { render, staticRenderFns } from "./ManagePage.vue?vue&type=template&id=561f518a&scoped=true&"
import script from "./ManagePage.vue?vue&type=script&lang=js&"
export * from "./ManagePage.vue?vue&type=script&lang=js&"
import style0 from "./ManagePage.vue?vue&type=style&index=0&id=561f518a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f518a",
  null
  
)

export default component.exports